import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getFirestoreDb } from '@/lib/firebase';
import { shouldSkipOrgLiveUpdate } from '@/lib/orgSnapshotGuard';

export function useOrgSettingsDoc(
  orgId: string | null,
  docId: string,
  enabled = true
) {
  const { user } = useAuth();
  const [raw, setRaw] = useState<Record<string, unknown> | null>(null);
  const [loading, setLoading] = useState(Boolean(orgId && enabled));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!orgId || !enabled || !user?.uid) {
      setRaw(null);
      setLoading(false);
      setError(null);
      return;
    }

    const uid = user.uid;
    setLoading(true);
    setError(null);

    return onSnapshot(
      doc(getFirestoreDb(), 'organizations', orgId, 'settings', docId),
      (snap) => {
        if (shouldSkipOrgLiveUpdate(snap.metadata, uid, orgId)) return;
        setRaw(snap.exists() ? (snap.data() ?? {}) : null);
        setLoading(false);
      },
      (e) => {
        setError(e.message);
        setRaw(null);
        setLoading(false);
      }
    );
  }, [orgId, docId, enabled, user?.uid]);

  return { raw, loading, error };
}
